import { createSelector } from 'reselect';
import { getReportExport } from '../rootSelectors';

const getShowReportExportModal = createSelector([getReportExport], open => open);

export { getShowReportExportModal };
